var AbstractPlayerTech   = require("./AbstractPlayerTech"),
    ImageProgressTracker = require("app/MediaPlayer/ProgressTrackers/ImageProgressTracker"),
    kind                 = require("enyo/kind");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.Astract.AbstractImageViewer.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.Astract.AbstractImageViewer",

    /**
     * @private
     */
    kind: AbstractPlayerTech,

    /**
     * @private
     */
    classes: "app-media-player-image-viewer",

    // Common Components
    // --------------------------------

    /**
     * The tracker kind to use.
     *
     * @type  {Function}
     * @public
     */
    trackerKind: ImageProgressTracker,

    // Viewer API
    // --------------------------------

    /**
     * The following methods *must* be implemented in order for the viewer to be
     * compatible with the rest of the application.
     */

    /**
     * Hide the controls (this may not be possible for every viewer).
     *
     * @returns  {boolean}  `true` if hidden, `false` otherwise.
     * @public
     */
    hideControls: function() {
        return false;
    },

    /**
     * Show the controls (this may not be possible for every viewer).
     *
     * @returns  {boolean}  `true` if showing, `false` otherwise.
     * @public
     */
    showControls: function() {
        return false;
    }

});
